import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const PlanningReport = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const [inputs, setInputs] = useState({
    query_month: "", // Default value for the month dropdown
  });

  function getCurrentDate() {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    return `${year}-${month}-${day}`;
  }

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const fetchData = () => {
    Http.get("/report-leave-report").then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  // const formSubmit = () => {
  //   Http.get(
  //     "/movement-slip?from=" +
  //       inputs.from +
  //       "&to=" +
  //       inputs.to +
  //       "&staff=" +
  //       inputs.hr_staff_basic_info_id
  //   ).then((res) => {
  //     setReceiveData(res.data);
  //   });
  // };

  const formSubmit = () => {
    Http.get(
      `/movement-slip?month=${inputs.query_month}&staff=${inputs.hr_staff_basic_info_id}`
    ).then((res) => {
      setReceiveData(res.data);
    });
  };
  

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Planning Report</h5>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <div className="col-3"></div>
                <div className="col-6">
                  <div className="row">
                  <div className="col-lg">
  <select
    className="form-control margin-bottom-on-mobile"
    name="query_month"
    value={inputs.query_month || ""}
    onChange={handleChange}
  >
    <option value="">Select Month</option>
    <option value="01">January</option>
    <option value="02">February</option>
    <option value="03">March</option>
    <option value="04">April</option>
    <option value="05">May</option>
    <option value="06">June</option>
    <option value="07">July</option>
    <option value="08">August</option>
    <option value="09">September</option>
    <option value="10">October</option>
    <option value="11">November</option>
    <option value="12">December</option>
  </select>
</div>

                    <div className="col-lg">
                      <button
                        className="btn btn-primary btn-block mg-b-10"
                        onClick={formSubmit}
                      >
                        <i className="fa fa-send mg-r-10"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-3"></div>
              </div>
            </div>
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              {/* <h6 className="card-body-title mg-sm-b-30">Datatable</h6> */}
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <h5 className="text-uppercase text-sm font-weight-bolder">
                      Artisan Ceramics Limited
                    </h5>
                    <p>House-16, Road-07, Sector-01, Uttara, Dhaka</p>
                  </div>
                  <div className="table-responsive p-0 pb-2">
                    <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 _datatable">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            S/N
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Item Name
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Thun Order #3030
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Home Brands #4716952
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Home Brands #4717679
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Lagerhaus #00022551
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            BGH #02-2024
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Aarong #293-341
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Total Qty
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            01
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            31 cm Round Plate
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Art-01
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                        </tr>
                        <tr>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            02
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            31 cm Round Plate (Red)
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Art-01
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            2016
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            2076
                          </td>
                        </tr>
                        <tr>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            03
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            28 cm Dinner Plate (SMB)
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Art-01
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                        </tr>
                        <tr>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            04
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            27 cm Dinner Plate
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Art-01
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                        </tr>
                        <tr>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            05
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            27 cm Dinner Plate (Red)
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Art-01
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                        </tr>
                        <tr>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            06
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            27 cm Dinner Plate (Olive)
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Art-01
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                        </tr>
                        {/* {receiveData &&
                          receiveData.map((item, index) => (
                            <>
                              <tr key={item.id}>
                                <td className="text-xs">{index + 1}</td>
                                <td className="text-xs" colSpan={13}>
                                  <b>{item.dept_name}</b>
                                </td>
                              </tr>
                              {item.staff.map((item2, index2) => (
                                <tr key={item2.id}>
                                  <td className="text-xs"></td>
                                  <td className="text-xs">{item2.name}</td>
                                  <td className="text-xs">{item.casual}</td>
                                  <td className="text-xs">{item.sick}</td>
                                  <td className="text-xs">{item.earn}</td>
                                  <td className="text-xs">{item.others}</td>
                                  <td className="text-xs">{item2.casual}</td>
                                  <td className="text-xs">{item2.sick}</td>
                                  <td className="text-xs">{item2.earn}</td>
                                  <td className="text-xs">{item2.others}</td>
                                </tr>
                              ))}
                            </>
                          ))} */}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            className="text-uppercase text-dark text-sm font-weight-bolder ps-2"
                            colSpan={3}
                          >
                            Total
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            120
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            2016
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            60
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            120
                          </td>
                          <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            2376
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanningReport;
